namespace TabAurous.OMS {
    export interface ProductInspectionRow {
        Id?: number;
        TemplateId?: number;
        ProductId?: number;
        ProcessId?: number;
        Parameter?: string;
        Value?: string;
        IsNumeric?: boolean;
        Min?: number;
        Max?: number;
    }

    export namespace ProductInspectionRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Parameter';
        export const localTextPrefix = 'OMS.ProductInspection';
        export const deletePermission = 'Products:Delete';
        export const insertPermission = 'Products:Add';
        export const readPermission = '*';
        export const updatePermission = 'Products:Edit';

        export declare const enum Fields {
            Id = "Id",
            TemplateId = "TemplateId",
            ProductId = "ProductId",
            ProcessId = "ProcessId",
            Parameter = "Parameter",
            Value = "Value",
            IsNumeric = "IsNumeric",
            Min = "Min",
            Max = "Max"
        }
    }
}
